<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					}, maxWidth: {
						name: 'maxWidth',
						defaultValue: '500',
						min: '200',
						max: '768',
						labelDesc: 'max-width-tablet',
						callback: function () {
							vm.resources.maxWidth.defaultValue = this.value;
							vm.element.internal_config.maxWidth = this.value + 'px';

						},
					},

					horizontal: {
						name: 'horizontal',
						defaultValue: false,
						labelDesc: 'horizontal-form',
						callback: function () {
							vm.resources.horizontal.defaultValue = this.value;
							vm.element.internal_config.horizontal = this.value;
						},
					},
					showLabel: {
						name: 'showLabel',
						defaultValue: '',
						labelDesc: 'show-label',
						callback: function () {
							vm.resources.showLabel.defaultValue = this.value;
							vm.element.internal_config.showLabel = this.value;


							vm.element.buildFields(vm.element);
						},
					},
					showPlaceholder: {
						name: 'showPlaceholder',
						defaultValue: '',
						labelDesc: 'show-placeholder',
						callback: function () {
							vm.resources.showPlaceholder.defaultValue = this.value;
							vm.element.internal_config.showPlaceholder = this.value;


							vm.element.buildFields(vm.element);
						},
					},

					text: {
						name: 'text',
						defaultValue: '',
						labelDesc: 'text',
						canRemove: false,
						callback: function () {
							vm.resources.text.defaultValue = this.value;
							vm.element.internal_config.button.text = this.value;

							vm.element.internal_config.button.backgroundColor = vm.resources.backgroundColor.defaultValue;
						},
					},
					subtext: {
						name: 'subtext',
						defaultValue: '',
						labelDesc: 'subtext',
						canRemove: false,
						callback: function () {
							vm.resources.subtext.defaultValue = this.value;
							vm.element.internal_config.button.subtext = this.value;
							vm.element.internal_config.button.subText = this.value;

							vm.element.internal_config.button.backgroundColor = vm.resources.backgroundColor.defaultValue;
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.button.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.button.borderRadius = value;
						},
					},
					inputRadius: {
						name: 'inputRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'inputRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.inputRadius.defaultValue = value;
							vm.element.internal_config.inputRadius = value;

							vm.element.inputStyle();
						},
					},
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.button.backgroundColor = this.colorValue;
						},
					},
					inputBorder: {
						name: 'inputBorder',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'input-border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.inputBorder.defaultValue = value;
							vm.element.internal_config.inputBorder = value;

							vm.element.inputStyle();
						},
					},
					inputColor: {
						name: 'inputColor',
						defaultValue: '#ffffff',
						labelDesc: 'input-bg-color',
						callback: function () {
							vm.resources.inputColor.defaultValue = this.colorValue;
							vm.element.internal_config.inputBgColor = this.colorValue;

							vm.element.inputStyle();
						},
					},
					labelStyle: {
						name: 'labelStyle',
						defaultValue: '#ffffff',
						labelDesc: 'input-label-color',
						callback: function () {
							vm.resources.labelStyle.defaultValue = this.colorValue;
							vm.element.internal_config.labelStyle = this.colorValue;

							vm.element.inputStyle();
						},
					},
					inputHeight: {
						name: 'inputHeight',
						defaultValue: '38',
						min: '5',
						max: '100',
						labelDesc: 'input-height',
						callback: function () {

							vm.resources.inputHeight.defaultValue = this.value;
							vm.element.internal_config.inputHeight = this.value + 'px';

							vm.element.inputStyle();
						},
					},
          textareaHeight: {
            name: 'textareaHeight',
            defaultValue: '38',
            min: '5',
            max: '300',
            labelDesc: 'textarea-height',
            callback: function() {
              vm.resources.textareaHeight.defaultValue = this.value;
              vm.element.internal_config.textareaHeight = this.value + 'px';

              vm.element.inputStyle();
            }
          },
					backgroundColorHover: {
						name: 'backgroundColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color-hover',
						callback: function () {
							vm.resources.backgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.button.backgroundColorHover = this.colorValue;
						},
					},
					textColorHover: {
						name: 'textColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color-text-hover',
						callback: function () {
							vm.resources.textColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.button.textColorHover = this.colorValue;
						},
					},
					// src: {
					// 	name: 'src',
					// 	defaultValue: '',
					// 	labelDesc: 'bg-image',
					// 	canRemove: true,
					// 	callback: function () {
					// 		vm.resources.src.defaultValue = this.value;
					// 		vm.element.internal_config.button.backgroundImage = this.value;
					//
					// 		//force apply new bg
					// 		let color = vm.element.internal_config.button.backgroundColor;
					// 		vm.element.internal_config.button.backgroundColor = '#FFFFFF';
					// 		vm.element.internal_config.button.backgroundColor = color;
					// 	},
					// },
					// backgroundConfig: {
					// 	name: 'backgroundConfig',
					// 	defaultValueOrigin: '',
					// 	defaultValueSize: '',
					// 	defaultValueRepeat: '',
					// 	labelDesc: 'backgroundConfig',
					// 	canRemove: true,
					// 	callback: function () {
					// 		vm.resources.backgroundConfig.defaultValueOrigin = this.origin;
					// 		vm.resources.backgroundConfig.defaultValueRepeat = this.repeat;
					// 		vm.resources.backgroundConfig.defaultValueSize = this.size;
					//
					// 		vm.element.internal_config.button.backgroundOrigin = this.origin;
					// 		vm.element.internal_config.button.backgroundRepeat = this.repeat;
					// 		vm.element.internal_config.button.backgroundSize = this.size;
					//
					// 		//force apply new bg
					// 		let color = vm.element.internal_config.button.backgroundColor;
					// 		vm.element.internal_config.button.backgroundColor = '#FFFFFF';
					// 		vm.element.internal_config.button.backgroundColor = color;
					// 	},
					// },
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.button.boxShadow = value;
						},
					},
					icon: {
						name: 'icon',
						defaultIcon: '',
						defaultPosition: 'left',
						labelDesc: 'icon',
						callback: function () {

							vm.resources.icon.defaultIcon = this.iconSelected;
							vm.resources.icon.defaultPosition = this.position;

							vm.element.internal_config.button.icon = this.iconSelected;
							vm.element.internal_config.button.iconPosition = this.position;

							vm.element.buildIcon();
						},
					},
					textStyle: {
						name: 'textStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						defaultWeight: '',
						defaultStyle: '',
						labelDesc: 'textStyle',
						callback: function () {

							vm.resources.textStyle.defaultFamily = this.family;
							vm.element.internal_config.button.textStyle.family = this.family;

							vm.resources.textStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.button.textStyle.size = this.size + 'px';

							vm.resources.textStyle.defaultColor = this.color;
							vm.element.internal_config.button.textStyle.color = this.color;

							vm.resources.textStyle.defaultAlign = this.align;
							vm.element.internal_config.button.textStyle.align = this.align;

							vm.resources.textStyle.defaultWeight = this.weight;
							vm.element.internal_config.button.textStyle.weight = this.weight;

							vm.resources.textStyle.defaultStyle = this.style;
							vm.element.internal_config.button.textStyle.style = this.style;

						},
					},
					subTextStyle: {
						name: 'subTextStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						labelDesc: 'subTextStyle',
						callback: function () {

							vm.resources.subTextStyle.defaultFamily = this.family;
							vm.element.internal_config.button.subTextStyle.family = this.family;

							vm.resources.subTextStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.button.subTextStyle.size = this.size + 'px';

							vm.resources.subTextStyle.defaultColor = this.color;
							vm.element.internal_config.button.subTextStyle.color = this.color;

							vm.resources.subTextStyle.defaultAlign = this.align;
							vm.element.internal_config.button.subTextStyle.align = this.align;

							vm.resources.subTextStyle.defaultWeight = this.weight;
							vm.element.internal_config.button.subTextStyle.weight = this.weight;

							vm.resources.subTextStyle.defaultStyle = this.style;
							vm.element.internal_config.button.subTextStyle.style = this.style;

						},
					},
					inputStyle: {
						name: 'inputStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						labelDesc: 'inputStyle',
						callback: function () {

							vm.resources.inputStyle.defaultFamily = this.family;
							vm.element.internal_config.inputStyle.family = this.family;

							vm.resources.inputStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.inputStyle.size = this.size + 'px';

							vm.resources.inputStyle.defaultColor = this.color;
							vm.element.internal_config.inputStyle.color = this.color;

							vm.resources.inputStyle.defaultAlign = this.align;
							vm.element.internal_config.inputStyle.align = this.align;

							vm.resources.inputStyle.defaultWeight = this.weight;
							vm.element.internal_config.inputStyle.weight = this.weight;

							vm.resources.inputStyle.defaultStyle = this.style;
							vm.element.internal_config.inputStyle.style = this.style;

							vm.element.inputStyle();

						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
					width: {
						name: 'width',
						defaultValue: '50',
						min: '20',
						max: '100',
						labelDesc: 'width-button',
						callback: function () {
							vm.resources.width.defaultValue = this.value;
							vm.element.internal_config.button.width = this.value + '%';
						},
					},
          height: {
            name: 'height',
            defaultValue: '50',
            min: '20',
            max: '100',
            labelDesc: 'height-button',
            callback: function() {
              vm.resources.height.defaultValue = this.value;
              vm.element.internal_config.button.height = parseInt(this.value) + 'px';
            }
          }
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;

				this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

				//form
				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

				//input
				this.resources.inputColor.defaultValue = data.internal_config.inputBgColor;
				this.resources.labelStyle.defaultValue = data.internal_config.labelStyle;
				this.resources.inputBorder.defaultValue = data.internal_config.inputBorder;
				this.resources.inputHeight.defaultValue = data.internal_config.inputHeight;
        if (!data.internal_config.textareaHeight) {
          this.$nextTick(() => {
            var textareaHeightNumber = $(data.$el).find('textarea.form-control:visible').outerHeight();
            var textareaHeight = (textareaHeightNumber || 54) + 'px'

            this.resources.textareaHeight.defaultValue = textareaHeight;
          });
        } else {
          this.resources.textareaHeight.defaultValue = data.internal_config.textareaHeight;
        }
				this.resources.inputRadius.defaultValue = data.internal_config.inputRadius;

				this.resources.inputStyle.defaultFamily = data.internal_config.inputStyle.family;
				this.resources.inputStyle.defaultSize = data.internal_config.inputStyle.size;
				this.resources.inputStyle.defaultColor = data.internal_config.inputStyle.color;
				this.resources.inputStyle.defaultAlign = data.internal_config.inputStyle.align;
				this.resources.inputStyle.defaultWeight = data.internal_config.inputStyle.weight;
				this.resources.inputStyle.defaultStyle = data.internal_config.inputStyle.style;

				this.resources.horizontal.defaultValue = data.internal_config.horizontal;
				//button
				this.resources.width.defaultValue = parseInt(data.internal_config.button.width);

				this.resources.text.defaultValue = data.internal_config.button.text;
				this.resources.subtext.defaultValue = data.internal_config.button.subText;

				this.resources.border.defaultValue = data.internal_config.button.border;
				this.resources.borderRadius.defaultValue = data.internal_config.button.borderRadius;
				this.resources.boxShadow.defaultValue = data.internal_config.button.boxShadow;

				this.resources.backgroundColor.defaultValue = data.internal_config.button.backgroundColor;
				this.resources.backgroundColorHover.defaultValue = data.internal_config.button.backgroundColorHover;
				this.resources.textColorHover.defaultValue = data.internal_config.button.textColorHover;
				// this.resources.src.defaultValue = data.internal_config.button.backgroundImage;
				// this.resources.backgroundConfig.defaultValueOrigin = data.internal_config.button.backgroundOrigin;
				// this.resources.backgroundConfig.defaultValueRepeat = data.internal_config.button.backgroundRepeat;
				// this.resources.backgroundConfig.defaultValueSize = data.internal_config.button.backgroundSize;

				this.resources.textStyle.defaultFamily = data.internal_config.button.textStyle.family;
				this.resources.textStyle.defaultSize = data.internal_config.button.textStyle.size;
				this.resources.textStyle.defaultColor = data.internal_config.button.textStyle.color;
				this.resources.textStyle.defaultAlign = data.internal_config.button.textStyle.align;
				this.resources.textStyle.defaultWeight = data.internal_config.button.textStyle.weight;
				this.resources.textStyle.defaultStyle = data.internal_config.button.textStyle.style;

				this.resources.subTextStyle.defaultFamily = data.internal_config.button.subTextStyle.family;
				this.resources.subTextStyle.defaultSize = data.internal_config.button.subTextStyle.size;
				this.resources.subTextStyle.defaultColor = data.internal_config.button.subTextStyle.color;
				this.resources.subTextStyle.defaultAlign = data.internal_config.button.subTextStyle.align;
				this.resources.subTextStyle.defaultWeight = data.internal_config.button.subTextStyle.weight;
				this.resources.subTextStyle.defaultStyle = data.internal_config.button.subTextStyle.style;

				this.resources.icon.defaultIcon = data.internal_config.button.icon;
				this.resources.icon.defaultPosition = data.internal_config.button.iconPosition;

				this.resources.showLabel.defaultValue = data.internal_config.showLabel;
				this.resources.showPlaceholder.defaultValue = data.internal_config.showPlaceholder;

			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/GetResponseForm/Resources.vue